import * as CL from '@design-system/component-library';
import { useNotifications } from '../../public/site/NotificationProvider.js';
import { removeNotification } from '../../public/site/notificationStore.js';

import './NotificationContainer.scss';

export const NotificationContainer = () => {
  const { items } = useNotifications();
  return (
    <div className="of-notification-container">
      {items.map(notification => (
        <div className="of-notification" key={notification.id}>
          <CL.Notification
            hasCloseButton={notification.hasCloseButton}
            id={notification.id}
            onNotificationHide={element => {
              if (notification.onNotificationHide) {
                notification.onNotificationHide(element);
              }
              if (notification.id !== undefined) {
                removeNotification(notification.id);
              }
            }}
            text={notification.text}
            timer={notification.timer}
            type={notification.type}
            visible={true}
          />
        </div>
      ))}
    </div>
  );
};
